// Dummy data for the Asset Leasing Management System

export const assets = [
  {
    id: 'AST-001',
    name: 'Office Building - Downtown',
    type: 'Real Estate',
    subtype: 'Commercial Building',
    department: 'Corporate',
    status: 'Active',
    purchaseDate: '2020-01-15',
    vendor: 'Metro Properties Ltd.',
    cost: 2500000,
    depreciationMethod: 'Straight Line',
    location: '123 Main Street, Downtown',
    assignedTo: 'Corporate Office',
    currentValue: 2200000,
    lastMaintenance: '2024-01-15',
    nextMaintenance: '2024-07-15'
  },
  {
    id: 'AST-002',
    name: 'Fleet Vehicle - Toyota Camry',
    type: 'Vehicle',
    subtype: 'Sedan',
    department: 'Sales',
    status: 'Active',
    purchaseDate: '2022-03-20',
    vendor: 'AutoMax Dealership',
    cost: 35000,
    depreciationMethod: 'Declining Balance',
    location: 'Sales Office',
    assignedTo: 'John Smith',
    currentValue: 28000,
    lastMaintenance: '2024-02-10',
    nextMaintenance: '2024-05-10'
  },
  {
    id: 'AST-003',
    name: 'Industrial Machinery - CNC Lathe',
    type: 'Machinery',
    subtype: 'Manufacturing Equipment',
    department: 'Production',
    status: 'Active',
    purchaseDate: '2021-06-10',
    vendor: 'Industrial Solutions Inc.',
    cost: 150000,
    depreciationMethod: 'Units of Production',
    location: 'Production Floor A',
    assignedTo: 'Production Team',
    currentValue: 120000,
    lastMaintenance: '2024-01-20',
    nextMaintenance: '2024-04-20'
  },
  {
    id: 'AST-004',
    name: 'IT Equipment - Server Rack',
    type: 'IT Equipment',
    subtype: 'Server Hardware',
    department: 'IT',
    status: 'Active',
    purchaseDate: '2023-02-15',
    vendor: 'TechCorp Solutions',
    cost: 45000,
    depreciationMethod: 'Straight Line',
    location: 'Data Center',
    assignedTo: 'IT Department',
    currentValue: 40000,
    lastMaintenance: '2024-02-01',
    nextMaintenance: '2024-08-01'
  },
  {
    id: 'AST-005',
    name: 'Warehouse Facility',
    type: 'Real Estate',
    subtype: 'Warehouse',
    department: 'Logistics',
    status: 'Active',
    purchaseDate: '2019-11-30',
    vendor: 'Industrial Properties Group',
    cost: 1800000,
    depreciationMethod: 'Straight Line',
    location: 'Industrial Zone',
    assignedTo: 'Logistics Team',
    currentValue: 1600000,
    lastMaintenance: '2024-01-05',
    nextMaintenance: '2024-07-05'
  },
  {
    id: 'AST-006',
    name: 'Office Furniture Set',
    type: 'Furniture',
    subtype: 'Office Furniture',
    department: 'HR',
    status: 'Active',
    purchaseDate: '2023-05-12',
    vendor: 'Office Solutions Ltd.',
    cost: 15000,
    depreciationMethod: 'Straight Line',
    location: 'HR Department',
    assignedTo: 'HR Team',
    currentValue: 13500,
    lastMaintenance: '2024-01-10',
    nextMaintenance: '2024-07-10'
  },
  {
    id: 'AST-007',
    name: 'Delivery Truck - Ford Transit',
    type: 'Vehicle',
    subtype: 'Commercial Vehicle',
    department: 'Logistics',
    status: 'Under Maintenance',
    purchaseDate: '2021-09-08',
    vendor: 'Commercial Vehicles Inc.',
    cost: 42000,
    depreciationMethod: 'Declining Balance',
    location: 'Service Center',
    assignedTo: 'Logistics Team',
    currentValue: 32000,
    lastMaintenance: '2024-02-15',
    nextMaintenance: '2024-03-15'
  },
  {
    id: 'AST-008',
    name: 'Laptop Computers - Dell XPS',
    type: 'IT Equipment',
    subtype: 'Computer Hardware',
    department: 'IT',
    status: 'Active',
    purchaseDate: '2023-08-20',
    vendor: 'Computer World',
    cost: 25000,
    depreciationMethod: 'Straight Line',
    location: 'IT Department',
    assignedTo: 'Development Team',
    currentValue: 22000,
    lastMaintenance: '2024-02-20',
    nextMaintenance: '2024-08-20'
  }
];

export const contracts = [
  {
    id: 'CT-2024-001',
    type: 'Lease-in',
    title: 'Office Space Lease Agreement',
    counterparty: 'Metro Properties Ltd.',
    startDate: '2024-01-01',
    endDate: '2024-12-31',
    status: 'Active',
    linkedAssets: ['AST-001'],
    paymentTerms: 'Monthly',
    frequency: 'Monthly',
    amount: 15000,
    autoRenewal: true,
    terminationClause: '30 days notice required',
    version: 1,
    createdBy: 'Admin User',
    createdAt: '2024-01-01T00:00:00Z',
    lastModified: '2024-01-01T00:00:00Z'
  },
  {
    id: 'CT-2024-002',
    type: 'Lease-out',
    title: 'Vehicle Lease Agreement',
    counterparty: 'ABC Transport Company',
    startDate: '2024-02-01',
    endDate: '2025-01-31',
    status: 'Active',
    linkedAssets: ['AST-002'],
    paymentTerms: 'Monthly',
    frequency: 'Monthly',
    amount: 2500,
    autoRenewal: false,
    terminationClause: '60 days notice required',
    version: 1,
    createdBy: 'Admin User',
    createdAt: '2024-02-01T00:00:00Z',
    lastModified: '2024-02-01T00:00:00Z'
  },
  {
    id: 'CT-2024-003',
    type: 'Service',
    title: 'Maintenance Service Agreement',
    counterparty: 'Industrial Solutions Inc.',
    startDate: '2024-01-15',
    endDate: '2024-12-31',
    status: 'Active',
    linkedAssets: ['AST-003'],
    paymentTerms: 'Quarterly',
    frequency: 'Quarterly',
    amount: 5000,
    autoRenewal: true,
    terminationClause: '90 days notice required',
    version: 1,
    createdBy: 'Admin User',
    createdAt: '2024-01-15T00:00:00Z',
    lastModified: '2024-01-15T00:00:00Z'
  },
  {
    id: 'CT-2024-004',
    type: 'Insurance',
    title: 'Property Insurance Policy',
    counterparty: 'Global Insurance Co.',
    startDate: '2024-01-01',
    endDate: '2024-12-31',
    status: 'Active',
    linkedAssets: ['AST-001', 'AST-005'],
    paymentTerms: 'Annual',
    frequency: 'Annual',
    amount: 25000,
    autoRenewal: true,
    terminationClause: '30 days notice required',
    version: 1,
    createdBy: 'Admin User',
    createdAt: '2024-01-01T00:00:00Z',
    lastModified: '2024-01-01T00:00:00Z'
  },
  {
    id: 'CT-2024-005',
    type: 'Lease-in',
    title: 'IT Equipment Lease',
    counterparty: 'TechCorp Solutions',
    startDate: '2024-03-01',
    endDate: '2027-02-28',
    status: 'Active',
    linkedAssets: ['AST-004', 'AST-008'],
    paymentTerms: 'Monthly',
    frequency: 'Monthly',
    amount: 3500,
    autoRenewal: false,
    terminationClause: '90 days notice required',
    version: 1,
    createdBy: 'Admin User',
    createdAt: '2024-03-01T00:00:00Z',
    lastModified: '2024-03-01T00:00:00Z'
  },
  {
    id: 'CT-2024-006',
    type: 'Lease-out',
    title: 'Warehouse Sublease Agreement',
    counterparty: 'Logistics Partners Ltd.',
    startDate: '2024-02-15',
    endDate: '2025-02-14',
    status: 'Active',
    linkedAssets: ['AST-005'],
    paymentTerms: 'Monthly',
    frequency: 'Monthly',
    amount: 12000,
    autoRenewal: true,
    terminationClause: '60 days notice required',
    version: 1,
    createdBy: 'Admin User',
    createdAt: '2024-02-15T00:00:00Z',
    lastModified: '2024-02-15T00:00:00Z'
  }
];

export const contractVersions = [
  {
    id: 'CT-2024-001',
    version: 1,
    changes: 'Initial contract creation',
    modifiedBy: 'Admin User',
    modifiedAt: '2024-01-01T00:00:00Z',
    status: 'Active'
  },
  {
    id: 'CT-2024-002',
    version: 1,
    changes: 'Initial contract creation',
    modifiedBy: 'Admin User',
    modifiedAt: '2024-02-01T00:00:00Z',
    status: 'Active'
  }
];

export const assignments = [
  {
    id: 1,
    assetId: 'AST-002',
    assetName: 'Fleet Vehicle - Toyota Camry',
    assignedTo: 'John Smith',
    assignedToType: 'Employee',
    department: 'Sales',
    assignedDate: '2024-01-15',
    status: 'Active',
    location: 'Sales Office'
  },
  {
    id: 2,
    assetId: 'AST-003',
    assetName: 'Industrial Machinery - CNC Lathe',
    assignedTo: 'Production Team',
    assignedToType: 'Department',
    department: 'Production',
    assignedDate: '2024-01-10',
    status: 'Active',
    location: 'Production Floor A'
  },
  {
    id: 3,
    assetId: 'AST-004',
    assetName: 'IT Equipment - Server Rack',
    assignedTo: 'IT Department',
    assignedToType: 'Department',
    department: 'IT',
    assignedDate: '2024-02-01',
    status: 'Active',
    location: 'Data Center'
  }
];

export const maintenanceRecords = [
  {
    id: 1,
    assetId: 'AST-002',
    assetName: 'Fleet Vehicle - Toyota Camry',
    type: 'Scheduled',
    description: 'Regular oil change and inspection',
    scheduledDate: '2024-02-10',
    completedDate: '2024-02-10',
    status: 'Completed',
    cost: 150,
    vendor: 'AutoMax Service Center',
    notes: 'All systems functioning normally'
  },
  {
    id: 2,
    assetId: 'AST-003',
    assetName: 'Industrial Machinery - CNC Lathe',
    type: 'Preventive',
    description: 'Monthly calibration and cleaning',
    scheduledDate: '2024-01-20',
    completedDate: '2024-01-20',
    status: 'Completed',
    cost: 500,
    vendor: 'Industrial Solutions Inc.',
    notes: 'Calibration within tolerance'
  },
  {
    id: 3,
    assetId: 'AST-007',
    assetName: 'Delivery Truck - Ford Transit',
    type: 'Repair',
    description: 'Engine diagnostic and repair',
    scheduledDate: '2024-02-15',
    completedDate: null,
    status: 'In Progress',
    cost: 0,
    vendor: 'Commercial Vehicles Inc.',
    notes: 'Engine misfire detected, parts ordered'
  }
];

export const valuationRules = [
  {
    id: 1,
    name: 'Straight Line Depreciation',
    method: 'Straight Line',
    rate: 10,
    description: 'Standard straight line depreciation at 10% per year',
    applicableTo: ['Real Estate', 'Furniture', 'IT Equipment']
  },
  {
    id: 2,
    name: 'Declining Balance - Vehicles',
    method: 'Declining Balance',
    rate: 20,
    description: 'Declining balance depreciation for vehicles at 20% per year',
    applicableTo: ['Vehicle']
  },
  {
    id: 3,
    name: 'Units of Production - Machinery',
    method: 'Units of Production',
    rate: 0.5,
    description: 'Depreciation based on production units',
    applicableTo: ['Machinery']
  }
];

export const departments = [
  { id: 1, name: 'Corporate', code: 'CORP' },
  { id: 2, name: 'Sales', code: 'SALES' },
  { id: 3, name: 'Production', code: 'PROD' },
  { id: 4, name: 'IT', code: 'IT' },
  { id: 5, name: 'Logistics', code: 'LOG' },
  { id: 6, name: 'HR', code: 'HR' }
];

export const assetTypes = [
  { id: 1, name: 'Real Estate', subtypes: ['Commercial Building', 'Warehouse', 'Office Space'] },
  { id: 2, name: 'Vehicle', subtypes: ['Sedan', 'Commercial Vehicle', 'Truck'] },
  { id: 3, name: 'Machinery', subtypes: ['Manufacturing Equipment', 'Production Equipment'] },
  { id: 4, name: 'IT Equipment', subtypes: ['Server Hardware', 'Computer Hardware', 'Network Equipment'] },
  { id: 5, name: 'Furniture', subtypes: ['Office Furniture', 'Conference Room Furniture'] }
];

export const contractTypes = [
  { id: 1, name: 'Lease-in', description: 'Assets leased from external parties' },
  { id: 2, name: 'Lease-out', description: 'Assets leased to external parties' },
  { id: 3, name: 'Service', description: 'Service agreements for maintenance' },
  { id: 4, name: 'Insurance', description: 'Insurance policies for assets' },
  { id: 5, name: 'Purchase', description: 'Asset purchase agreements' }
];

export const paymentFrequencies = [
  { id: 1, name: 'Monthly', days: 30 },
  { id: 2, name: 'Quarterly', days: 90 },
  { id: 3, name: 'Semi-Annual', days: 180 },
  { id: 4, name: 'Annual', days: 365 }
];

export const counterparties = [
  { id: 1, name: 'Metro Properties Ltd.', type: 'Lessor', contact: 'John Doe', email: 'john@metroproperties.com', phone: '+1-555-0101' },
  { id: 2, name: 'AutoMax Dealership', type: 'Vendor', contact: 'Jane Smith', email: 'jane@automax.com', phone: '+1-555-0102' },
  { id: 3, name: 'Industrial Solutions Inc.', type: 'Vendor', contact: 'Mike Johnson', email: 'mike@industrialsolutions.com', phone: '+1-555-0103' },
  { id: 4, name: 'TechCorp Solutions', type: 'Vendor', contact: 'Sarah Wilson', email: 'sarah@techcorp.com', phone: '+1-555-0104' },
  { id: 5, name: 'Global Insurance Co.', type: 'Insurance', contact: 'David Brown', email: 'david@globalinsurance.com', phone: '+1-555-0105' }
];
